import { render } from "./SocialSelector.vue?vue&type=template&id=0b0d1312"
import script from "./SocialSelector.vue?vue&type=script&lang=js"
export * from "./SocialSelector.vue?vue&type=script&lang=js"

import "./SocialSelector.vue?vue&type=style&index=0&id=0b0d1312&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__